import { render, staticRenderFns } from "./CartPreviewNewEcommerce.vue?vue&type=template&id=2c6f968c&scoped=true&"
import script from "./CartPreviewNewEcommerce.vue?vue&type=script&lang=ts&"
export * from "./CartPreviewNewEcommerce.vue?vue&type=script&lang=ts&"
import style0 from "./CartPreviewNewEcommerce.vue?vue&type=style&index=0&id=2c6f968c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6f968c",
  null
  
)

export default component.exports